import React, { useState } from "react";
import { Button } from "react-bootstrap";
import Preferences from "./Preferences";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { clearPreferences, setPreferences } from "../../../redux/preferencesSlice";
import getFormPreferences from "../../../api/getFormPreferences";
import { useQuery } from "react-query";

const MinimizableContainer = ({
  children,
  minimized,
  onMinimizeClick,
  // showPrefrence,
  Title,
  className,
  style = {},
  OptionsButton,
  HandleDownload
}) => {
  const [showPreferences, setShowPreferences] = useState(false);
  const dispatch = useDispatch();
  const selectedProject = useSelector(state => state.selectedProject);
  const { form_name } = useParams();
  
  const { data: preferences } = useQuery(
    ["getFormPreferences", form_name],
    () => getFormPreferences(selectedProject.name, form_name),
    {
      refetchOnWindowFocus: false,
      staleTime: 0,
      cacheTime: 0,
    }
  );

  const containerStyle = {
    border: "2px solid gray",
    // maxHeight: `${minimized ? "90px" : "1000px"}`,
    // minHeight: 'fit-content',
    maxHeight: 'calc(100vh - 145px)',
    flex: 1,
    // height: "auto",
    overflowY: `hidden`,
    padding: "20px 0px 0px 1px",
    borderRadius: "5px",
    ...style,
    transition: `max-height 500ms linear ${style.transition ? `,${style.transition}` : ""
      }`,
  };

  const titleStyle = {
    marginBottom: "14px",
  };

  const iconStyle = {
    fontWeight: "bolder",
    fontSize: "16px",
  };

  const toggleModel = () => {
    setShowPreferences(!showPreferences)
  }

  const handleClearPreferences = () => {
    dispatch(clearPreferences({ form_name }));
    // Réinitialiser le state local avec les préférences par défaut
    if (preferences?.data?.data) {
      let init = preferences.data.data;
      let filteredInit = init?.filter(obj => {
        return Object.values(obj)[0] === true;
      });

      const map = {};
      filteredInit?.forEach(obj => {
        Object.keys(obj).forEach(key => {
          map[key] = obj[key];
        });
      });
      
      dispatch(setPreferences(map));
    }
    
    // Ouvrir aussi la modal des préférences
    setShowPreferences(true);
  };

  return (
    <div className={className} style={containerStyle}>
      <div
        className="d-flex align-items-center justify-content-between"
        style={titleStyle}
      >
        <Title style={{ marginBottom: "0px" }} />
        <div class="d-flex" style={{ gap: "8px", marginRight: 12 }}>
          {OptionsButton && <OptionsButton />}
          {HandleDownload && <HandleDownload />}
          <Button variant="dark" size="sm" onClick={handleClearPreferences}><i className="ti-settings"></i></Button>
          {/* <Button variant="light" onClick={onMinimizeClick}>
            <i
              style={iconStyle}
              className={`${minimized ? "ti-plus" : "ti-minus"}`}
            />
          </Button> */}
        </div>
      </div>
      {children}
      <Preferences
        isActive={showPreferences}
        handleClose={toggleModel}
      />
    </div>
  );
};

export default MinimizableContainer;
